import type { AmzOverviewResponse } from "../../types/amazon";
import { fmtJst } from "../../lib/amazonContent";
import { Badge } from "./AmzUi";
import { SOURCE_TONE } from "./helpers";
import type { DetailTab, ProductFilter } from "./helpers";

interface DashboardViewProps {
  overview: AmzOverviewResponse;
  onFilter: (f: ProductFilter) => void;
  onOpen: (sku: string, tab: DetailTab) => void;
  onHistory: () => void;
}

export function DashboardView({ overview, onFilter, onOpen, onHistory }: DashboardViewProps) {
  const s = overview.stats;
  const stats: { label: string; value: number; color?: string; filter: ProductFilter }[] = [
    { label: "商品数", value: s.products, filter: "all" },
    { label: "要確認", value: s.review, filter: "review" },
    { label: "Listings Error", value: s.errors, color: "var(--amz-err)", filter: "error" },
    { label: "未登録", value: s.unregistered, filter: "unregistered" },
    { label: "下書き変更あり", value: s.draftChanged, color: "var(--amz-accent)", filter: "updated" },
    { label: "同期エラー", value: s.syncErrors, color: "var(--amz-err)", filter: "error" },
  ];
  return (
    <div className="amz-page dash">
      <div className="amz-head">
        <div className="amz-head-text">
          <h1 className="amz-h1">ダッシュボード</h1>
          <span className="amz-subtext">
            最終同期 {fmtJst(overview.lastListingsSyncAt)} · {s.products}商品
            {overview.writeLive ? "" : " · 本番書込ゲートは閉じています（閲覧・下書きのみ）"}
          </span>
        </div>
      </div>
      <div className="amz-stats">
        {stats.map((x) => (
          <button key={x.label} type="button" className="amz-stat" onClick={() => onFilter(x.filter)}>
            <span className="amz-stat-label">{x.label}</span>
            <span className="amz-stat-value" style={x.color ? { color: x.color } : undefined}>
              {x.value}
            </span>
          </button>
        ))}
      </div>
      <div className="amz-dash-grid">
        <section className="amz-section">
          <div className="amz-section-head">
            <h2>要確認</h2>
            <span>優先度順</span>
          </div>
          {overview.attention.length === 0 && <div className="amz-section-empty">要確認の項目はありません。</div>}
          {overview.attention.map((a, i) => (
            <button key={`${a.sku}-${a.level}-${i}`} type="button" className="amz-att-row" onClick={() => onOpen(a.sku, a.tab)}>
              <Badge tone={a.tone}>{a.level}</Badge>
              <div className="amz-att-main">
                <span className="amz-att-text">{a.text}</span>
                <span className="amz-att-sub">
                  {a.itemName ?? "（商品名なし）"} · <span className="amz-mono">{a.sku}</span>
                </span>
              </div>
              <span className="amz-att-open">開く</span>
            </button>
          ))}
        </section>
        <section className="amz-section">
          <div className="amz-section-head">
            <h2>最近の更新</h2>
            <a
              href="#"
              style={{ fontSize: 12 }}
              onClick={(e) => {
                e.preventDefault();
                onHistory();
              }}
            >
              すべて見る
            </a>
          </div>
          {overview.recent.length === 0 && <div className="amz-section-empty">更新履歴はまだありません。</div>}
          {overview.recent.map((h) => (
            <div key={h.id} className="amz-recent-row">
              <div className="amz-recent-top">
                <Badge tone={SOURCE_TONE[h.source]} size="sm" mono>
                  {h.source}
                </Badge>
                <span className="amz-recent-field">{h.field}</span>
              </div>
              <span className="amz-recent-sub">
                {fmtJst(h.createdAt)} · {h.user} · {h.sku}
              </span>
            </div>
          ))}
        </section>
      </div>
    </div>
  );
}
